module.exports = {
      id: "lulu-money-usage",
      viewBox: "0 0 398 134",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#lulu-money",
      toString: function () {
        return this.url;
      }
    }